module.exports = __webpack_public_path__ + "img/CCLF_infographic-07.0b40a065.png";